import constants from '../../../containers/widget/constants';
import algorithms from '../../../containers/widget/constants/algorithms';

export const initialState = {
	isFetching: false,
	algorithmType: algorithms.SIMILAR_VENDORS_BASED_ON_ACTIVITY,
	vendorToFindSimilar: null,
	similarAlgorithmType: null,
	recommendedVendors: [],
};

export default function similarVendorsBasedOnActivityReducer(
	state = initialState,
	action = null,
) {
	switch (action.type) {
		case constants.CLEAR_RECOMMENDED_VENDORS:
			return {
				...state,
				isFetching: false,
				vendorToFindSimilar: null,
				similarAlgorithmType: null,
				recommendedVendors: [],
			};
		case constants.FETCH_SIMILAR_VENDORS_BASED_ON_ACTIVITY:
			return {
				...state,
				isFetching: true,
			};
		case constants.FETCH_SIMILAR_VENDORS_BASED_ON_ACTIVITY_SUCCESS:
			if (action.payload.data.errors) {
				return {
					...state,
					isFetching: false,
					vendorToFindSimilar: null,
					similarAlgorithmType: null,
					recommendedVendors: [],
					errorMessage: action.payload.data.errors[0].message,
				};
			}

			return {
				...state,
				isFetching: true,
				vendorToFindSimilar: action.vendorToFindSimilar,
				similarAlgorithmType: action.similarAlgorithmType,
				recommendedVendors: action.payload.data.similarity.profiles,
			};

		case constants.FETCH_SIMILAR_VENDORS_BASED_ON_ACTIVITY_ERROR:
			return {
				...state,
				isFetching: false,
				vendorToFindSimilar: null,
				similarAlgorithmType: null,
				recommendedVendors: [],
				errorMessage: action.error,
			};
		default:
			return state;
	}
}
